module.exports = __webpack_public_path__ + "azure-vm.1f42b160f106cd35746c9123d2dce4fd.hashedasset.svg";